<template>
    <div>
        <default-navigation navbarClass="bg-primary"></default-navigation>
        <section class="bg-primary pt-0">
            <div class="custom-container">
                <div class="row justify-content-center">
                    <div class="col-xl-8 text-center">
                        <h1>Start een onderzoek</h1>
                        <p class="mb-4">Na het invullen van onderstaande velden krijgen alle door u geselecteerde medewerkers een e-mail met een link naar de vragenlijst van de RisicoRadar. U kunt
                                        naderhand via het resultaten-dashboard zien hoeveel medewerkers de vragenlijst hebben ingevuld en wat de resultaten zijn.</p>
                    </div>
                </div>
            </div>
        </section>
        <section class="pt-0 min-margin">
            <div class="custom-container">
                <form class="text-center" autocomplete="off" method="get" @submit="cancelSubmit($event)">
                    <div class="row justify-content-center">
                        <div class="col-xl-6">
                            <transition name="fade" mode="out-in">
                                <div class="alert alert-warning errors col-12 d-flex" role="alert" v-if="Object.keys(errors).length > 0">
                                    <i class="fi fi-rr-exclamation me-2"></i>
                                    <span>Vul alle verplichte velden in om door te gaan.</span>
                                </div>
                            </transition>
                            <TextField name="name" v-model="name" placeholder="Voornaam Achternaam" title="Uw naam" :cls="(hasError('name') ? 'is-invalid' : '')" />
                            <TextField type="email" v-model="email" name="email" placeholder="naam@voorbeeld.com" title="Uw e-mailadres" :cls="(hasError('email') ? 'is-invalid' : '')" />
                            <TextField name="department" v-model="department" placeholder="Naam van de afdeling die uw wilt onderzoeken" title="Naam van de afdeling die uw wilt onderzoeken"
                                       :cls="(hasError('department') ? 'is-invalid' : '')" />
                            <div class="form-floating datepicker mb-3">
                                <Datetime v-model="deadline" input-id="deadline" :input-class="'form-control' + (hasError('deadline') ? ' is-invalid' : '')" :min-datetime="new Date().toISOString()" />
                                <label id="deadline" v-if="deadline === ''">Uiterste inleverdatum</label>
                                <transition name="fade" mode="out-in">
                                    <div class="invalid-feedback text-start d-block" v-if="hasError('deadline')">
                                        Dit is een verplicht veld
                                    </div>
                                </transition>
                            </div>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="alert alert-warning col-xl-5 mt-3 d-flex" role="alert">
                            <i class="fi fi-rr-bell-ring me-2"></i>
                            <span>Alle antwoorden worden anoniem opgeslagen. De resultaten kunnen niet herleid worden naar een persoon.</span>
                        </div>
                        <div class="col-xl-8 text-center mt-3">
                            <p>Vul hieronder de e-mail adressen in van de medewerkers die u een vragenlijst wil sturen. De groep kan zo groot en divers zijn als u wil, maar om bruikbare conclusies te
                               kunnen trekken is het belangrijk de groep zo homogeen mogelijk te maken. Kies bijvoorbeeld voor alle medewerkers van de keuken, of de administratie. </p>
                        </div>
                        <div class="alert alert-warning col-xl-5 mt-3 d-flex text-start" role="alert">
                            <i class="fi fi-rr-bulb me-2"></i>
                            <span>Heeft u een rij in Excel met alle e-mailadressen? Of een tekstbestand met alle e-mailadressen? Plak ze gemakkelijk in een onderstaand veld, de adressen worden dan automatisch verspreid over de velden.</span>
                        </div>
                    </div>
                    <div class="row justify-content-center mt-4">
                        <div class="col-xl-6">
                            <TextField v-for="i in amountFields" :cls="(i === 1 && hasError('recipient_email') ? 'is-invalid' : '' )" name="recipient_email[]" :autocomplete="false"
                                       placeholder="naam@example.com"
                                       :title="'E-mailadres ' + i"
                                       :ref="'email-' + i"
                                       :key="i" />

                            <transition name="fade" mode="out-in">
                                <div class="alert alert-warning errors col-12 d-flex" role="alert" v-if="this.amountFields >= 100">
                                    <i class="fi fi-rr-exclamation me-2"></i>
                                    <span>Maximaal 100 e-mailadressen toegestaan!</span>
                                </div>
                                <a href="#" class="ms-3" @click="incrementFields($event)" v-if="this.amountFields < 100"><i class="fi fi-rr-plus me-2"></i> Nog een adres toevoegen</a>
                            </transition>
                            <div class="form-check justify-content-center d-flex mt-5 mb-5">
                                <input :class="'form-check-input' + (hasError('permission') ? ' is-invalid' : '')" type="checkbox" value="1" name="permission" id="flexCheckDefault">
                                <label class="form-check-label ms-3 gray-500" for="flexCheckDefault">
                                    Ja, ik heb toestemming om deze adressen te gebruiken voor dit onderzoek
                                </label>
                            </div>
                            <a :class="'btn btn-primary mx-auto' + (disabled ? ' disabled' : '')" @click="sendInquiry($event)">Onderzoek versturen</a>
                        </div>
                    </div>
                </form>
            </div>
        </section>
    </div>
</template>
<script>
import TextField from "../../includes/TextField";
import {Datetime} from 'vue-datetime';
import axios from 'axios';

export default {
    name:       'StartInquiry',
    components: { TextField, Datetime },
    data() {
        return {
            disabled:     false,
            amountFields: 5,
            name:         null,
            email:        null,
            department:   null,
            deadline:     null,
            errors:       {}
        }
    },
    methods: {
        incrementFields(event) {
            event.preventDefault();

            this.amountFields++;
        },

        sendInquiry(event) {
            event.preventDefault();

            this.disabled = true;

            const defaultText             = event.currentTarget.innerHTML;
            event.currentTarget.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>';

            const formData = new FormData(
                this.$el.querySelector('form')
            );

            formData.append('deadline', this.deadline);

            const buttonElement = event.currentTarget;
            const vm            = this;

            axios.post('/api/start-inquiry', formData).then((response) => {
                if(response.data.success === true) {
                    sessionStorage.setItem('inquiry-success', response.data.token)

                    this.$router.push({ path: '/onderzoek-versturen' });
                }
            }).catch((error) => {
                buttonElement.innerHTML = defaultText;

                console.log(error);

                vm.errors   = error.response.data.errors;
                vm.disabled = false;

                setTimeout(() => {
                    document.querySelector('.errors').scrollIntoView({ behavior: 'smooth' });
                }, 300);
            })
        },

        hasError(field) {
            return this.errors.hasOwnProperty(field);
        },

        setEmailAddresses(emails, pastedFrom) {

            if(emails.length > 0) {
                for(let i in this.$refs) {
                    if(this.$refs[i][0] === pastedFrom) {
                        this.$refs[i][0].$data.value = emails.shift();

                    } else if(this.$refs[i][0].$data.value === null) {
                        this.$refs[i][0].$data.value = emails.shift();

                    }
                }

                if(emails.length > 0) {
                    this.amountFields = (this.amountFields + emails.length) > 100 ? 100 : this.amountFields + emails.length;

                    Vue.nextTick(() => {
                        for(let i in this.$refs) {
                            if(this.$refs[i][0].$data.value === null) {
                                this.$refs[i][0].$data.value = emails.shift();
                            }
                        }
                    });
                }
            }
        },
        cancelSubmit(event) {
            event.preventDefault();
        }
    },
}
</script>
